import { useNextRouter } from '@/data/Content/_NextRouter';
import { personMutatorKeyMatcher, useLogin, UserLogon } from '@/data/Content/Login';
import { useLocalization } from '@/data/Localization';
import { Box, Drawer, Paper, Stack, Typography } from '@mui/material';
import { useSWRConfig } from 'swr';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';
import {
	DrawerLoginContentSx,
	DrawerLoginFrameSx,
	DrawerLoginHeaderIconBackSx,
	DrawerLoginHeaderIconCloseSx,
	DrawerLoginTitleSx,
} from '@/components/content/Cart/parts/DrawerLogin/styles/main';
import { SingleLoginForm } from '@/components/blocks/SingleLoginForm';
import { useRecaptchaV3Setup } from '@/data/Content/Recaptcha';
import { useCurrentRoute } from 'integration/hooks/useCurrentRoute';

interface DrawerLoginProps {
	type?: 'login' | 'wishlist';
	onGoBack: () => void;
	onClose: () => void;
}

export const DrawerLogin: React.FC<DrawerLoginProps> = ({ type = 'login', onGoBack, onClose }) => {
	const router = useNextRouter();
	const RouteLocal = useLocalization('Routes');
	const { mutate } = useSWRConfig();
	const { loginSubmit } = useLogin();
	const { recaptchaEnabled, recaptchaExecute, recaptchaLoading } = useRecaptchaV3Setup();
	const currentRoute = useCurrentRoute();

	const handleLogin = async (props: UserLogon) => {
		let x_recaptchaToken: string | undefined = undefined;

		if (recaptchaEnabled) {
			x_recaptchaToken = await recaptchaExecute('login');
		}

		const resp = await loginSubmit({ ...props, x_recaptchaToken });

		if ('userId' in resp ?? {}) {
			if (router.query.flow === 'checkout') {
				await router.push(RouteLocal.CheckOut.route.t());
			} else {
				await router.push(currentRoute);
			}

			/*
			await router.push({
				pathname: RouteLocal.Cart.route.t(),
				query: {
					auth: 'login',
				},
			});
			*/
			await mutate(personMutatorKeyMatcher(''), undefined);
			onClose();
		}
	};

	return (
		<Drawer open>
			<Paper sx={DrawerLoginFrameSx}>
				<Stack
					direction="row"
					justifyContent="space-between"
					width="100%"
					height="44px"
					position="relative"
				>
					<ArrowBackIosIcon sx={DrawerLoginHeaderIconBackSx} onClick={onGoBack} />
					<CloseIcon sx={DrawerLoginHeaderIconCloseSx} onClick={onClose} />
				</Stack>
				<Box sx={DrawerLoginContentSx}>
					<Typography sx={DrawerLoginTitleSx}>{'INICIA SESIÓN'}</Typography>
					<SingleLoginForm
						signInButtonLabel={type === 'wishlist' ? 'Iniciar sesión' : 'Comprar con mi cuenta'}
						forgotPasswordPosition="bottom"
						disabled={recaptchaLoading}
						onSubmit={handleLogin}
					/>
				</Box>
			</Paper>
		</Drawer>
	);
};
